import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ModelBoolStr, ModelNum, ModelNumStr, TicketsStato, TicketsStatoLng } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsStatoService extends CrudGenericsService<TicketsStato, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsStato`);
    this.base = `${env.apiUrl}/api/TicketsStato/`;
  }
  GetTicketsStato_Codici(): Observable<ModelNumStr[]> {
    const u = `${this.base}GetTicketsStato_Codici`;
    return this.http.get<ModelNumStr[]>(u);
  }
  // web
  GetAll_TicketsStatoLng(): Observable<TicketsStatoLng[]> {
    const u = `${this.base}GetAll_TicketsStatoLng`;
    return this.http.get<TicketsStatoLng[]>(u);
  }

  // web
  GetAll_TicketsStatoLng_ByIds(arr_ids_stato: number[]): Observable<TicketsStatoLng[]> {
    if (!arr_ids_stato || arr_ids_stato.length == 0) {
      return;
    } //mette in modello di post (meglio un json)
    let model: ModelNum[] = arr_ids_stato.map((x) => {
      return <ModelNum>{ Value: x };
    });
    const u = `${this.base}GetAll_TicketsStatoLng_ByIds`;
    return this.http.post<TicketsStatoLng[]>(u, model);
  }
  // ionic
  ShowBtnFeedback_ByTicket(id: number): Observable<ModelBoolStr> {
    const u = `${this.base}ShowBtnFeedback_ByTicket?id=${id}`;
    return this.http.get<ModelBoolStr>(u);
  }
}
